<section class="settings-reminder-cron">
  @if (!loading() && health() && !health()!.cronEnabled) {
    <div class="cg-admin-alert cg-admin-alert--warning settings-reminder-cron__banner">
      Task reminder emails and notifications are currently paused by the system administrator.
    </div>
  }

  @if (loadError(); as err) {
    <div class="cg-admin-alert cg-admin-alert--error">{{ err }}</div>
  }
  @if (saveError(); as err) {
    <div class="cg-admin-alert cg-admin-alert--error">{{ err }}</div>
  }

  <app-admin-card title="Reminder Service" icon="clock">
    <div class="settings-reminder-cron__toolbar">
      <div class="settings-reminder-cron__status">
        <span class="settings-reminder-cron__status-label">Scheduler status</span>
        @if (loading()) {
          <app-admin-skeleton variant="text" />
        } @else {
          <app-status-badge [variant]="statusVariant()">{{ schedulerStatusLabel() }}</app-status-badge>
        }
      </div>
      <app-admin-button
        variant="secondary"
        type="button"
        (click)="refresh()"
        [disabled]="loading() || refreshing() || savingEnabled()"
      >
        {{ refreshing() ? 'Refreshing…' : 'Refresh Status' }}
      </app-admin-button>
    </div>

    @if (!loading() && showHealthyNoRemindersNote()) {
      <div class="cg-admin-alert cg-admin-alert--success settings-reminder-cron__note">
        Scheduler is running normally. No reminders are currently due.
      </div>
    }

    @if (loading()) {
      <div class="settings-reminder-cron__grid">
        @for (item of [1, 2, 3, 4, 5, 6]; track item) {
          <app-admin-skeleton variant="text" />
        }
      </div>
    } @else if (health(); as data) {
      <p class="settings-reminder-cron__section-title">Scheduler health</p>
      <dl class="settings-reminder-cron__grid">
        <div class="settings-reminder-cron__item">
          <dt>Cron enabled</dt>
          <dd>{{ cronEnabledLabel() }}</dd>
        </div>
        <div class="settings-reminder-cron__item">
          <dt>Last heartbeat</dt>
          <dd>{{ data.lastHeartbeatAt ? (data.lastHeartbeatAt | date: 'medium') : '—' }}</dd>
        </div>
        <div class="settings-reminder-cron__item settings-reminder-cron__item--full">
          <dt>Last error</dt>
          <dd>{{ data.lastErrorMessage || '—' }}</dd>
        </div>
      </dl>

      <p class="settings-reminder-cron__section-title">Reminder activity</p>
      <dl class="settings-reminder-cron__grid">
        <div class="settings-reminder-cron__item">
          <dt>Next reminder due</dt>
          <dd>
            @if (data.nextReminderDueAt) {
              {{ data.nextReminderDueAt | date: 'medium' }}
            } @else {
              No upcoming reminders
            }
          </dd>
        </div>
        <div class="settings-reminder-cron__item">
          <dt>Pending reminder count</dt>
          <dd>
            @if (data.pendingReminderCount > 0) {
              {{ data.pendingReminderCount }}
            } @else {
              No pending reminders
            }
          </dd>
        </div>
        <div class="settings-reminder-cron__item">
          <dt>Last reminder processed</dt>
          <dd>{{ data.lastReminderProcessedAt ? (data.lastReminderProcessedAt | date: 'medium') : '—' }}</dd>
        </div>
        <div class="settings-reminder-cron__item">
          <dt>Total processed today</dt>
          <dd>{{ data.totalRemindersProcessedToday }}</dd>
        </div>
      </dl>

      @if (showManage()) {
        <div class="settings-reminder-cron__toggle">
          <div>
            <p class="settings-reminder-cron__toggle-title">Enable Task Reminder Cron</p>
            <p class="cg-form-help">
              When disabled, the scheduler stops processing reminder jobs immediately without deleting reminder data.
            </p>
          </div>
          <label class="cg-admin-toggle">
            <input
              type="checkbox"
              [ngModel]="data.cronEnabled"
              (ngModelChange)="onEnabledToggle($event)"
              [disabled]="!canManage() || savingEnabled()"
            />
            <span class="cg-admin-toggle__track"></span>
          </label>
        </div>
      }
    }
  </app-admin-card>
</section>
